import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Loader2, Upload } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface FileUploadDropzoneProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  primaryText: ReactNode
  secondaryText?: ReactNode
  loading?: boolean
  loadingText?: ReactNode
  dragActive?: boolean
  hasError?: boolean
}

export function FileUploadDropzone({
  primaryText,
  secondaryText,
  loading = false,
  loadingText,
  dragActive = false,
  hasError = false,
  className,
  disabled,
  ...props
}: FileUploadDropzoneProps) {
  return (
    <button
      type='button'
      disabled={disabled}
      className={cn(
        'flex min-h-[72px] w-full items-center gap-3 rounded-lg border border-dashed border-[#d9e2ec] bg-[#f4f5f8] px-4 py-3.5 text-left transition-colors hover:border-[#ff8a61] hover:bg-[#fff8f4] disabled:cursor-not-allowed disabled:opacity-50',
        dragActive && 'border-primary bg-[#fff1eb]',
        hasError && 'border-destructive',
        className
      )}
      {...props}
    >
      <span className='pointer-events-none inline-flex size-8 shrink-0 items-center justify-center rounded-lg bg-white text-[#171a20]'>
        {loading ? (
          <Loader2 className='size-4 animate-spin' />
        ) : (
          <Upload className='size-4' />
        )}
      </span>
      <span className='pointer-events-none min-w-0'>
        <span className='block text-sm leading-4 text-[#3D434E] mb-0.75'>
          {loading ? (loadingText ?? primaryText) : primaryText}
        </span>
        {!loading && secondaryText ? (
          <span className='mt-1 block text-xs leading-4 text-[#3D434E]'>
            {secondaryText}
          </span>
        ) : null}
      </span>
    </button>
  )
}

export default FileUploadDropzone
